import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useBreakpointDown } from '@travel-frontend/core';
import { useTranslation } from 'next-i18next';
import { useTravellersLabel } from '../../../../../../../components/SearchForm/components/TravellersField/hooks/useTravellersLabel.js';
import { useTravelDurationLabel } from '../../../../../../../components/SearchForm/components/TravelPeriodField/hooks/useTravelDurationLabel.js';
import { useTravelPeriodLabel } from '../../../../../../../components/SearchForm/components/TravelPeriodField/hooks/useTravelPeriodLabel.js';
import { LabelSmall } from '../../../../../../../primitives/index.js';
export const LastSearchesSubline = ({
  data
}) => {
  const {
    t
  } = useTranslation(['searchForm']);
  const mdDown = useBreakpointDown('md');
  const {
    travellers,
    travelPeriod,
    travellersMultiroom
  } = data.values;
  const travellersLabel = useTravellersLabel({
    adultCount: travellersMultiroom?.adultsCount ?? travellers?.adultCount,
    childrenCount: travellersMultiroom?.childrenCount ?? travellers?.childrenAges?.length ?? 0,
    short: mdDown
  });
  const travelDurationLabel = useTravelDurationLabel({
    minDuration: travelPeriod?.duration?.min || 0,
    maxDuration: travelPeriod?.duration?.max || 0
  });
  const travelPeriodLabel = useTravelPeriodLabel({
    startDate: travelPeriod?.startDate,
    endDate: travelPeriod?.endDate,
    showEndDateYear: false
  });
  const roomLabel = travellersMultiroom ? t('travellersFieldMultiroom.roomLabel', {
    count: travellersMultiroom?.rooms.length
  }) : null;
  return _jsx(LabelSmall, {
    children: `${travelPeriodLabel} - ${travelDurationLabel}, ${travellersLabel}${roomLabel ? ` - ${roomLabel}` : ''} `
  });
};